import axios from '../api';

export async function getUserByBarcode(eventId, barcode) {
  const { data } = await axios.get(`/events/${eventId}/wristbands/${barcode}`);
  return data;
}
